/* eslint-disable import/no-named-as-default-member */
import { PIPELINE, DEAD, CLOSED, REFINANCE, SOLD, ADDING_SUPPLEMENTAL } from "../constants/status";
import loanStatuses from "../constants/loanStatuses";

export function getFilteredLoanStatuses(availableLoanStatuses, currentLoanStatusId) {
  const filteredLoanStatuses = [];

  if (!availableLoanStatuses || availableLoanStatuses.length === 0) {
    return filteredLoanStatuses;
  }

  switch (currentLoanStatusId) {
    case loanStatuses.QUOTE:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.QUOTE)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.REJECTED_QUOTE)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.PASSED_QUOTE)[0]);
      break;
    case loanStatuses.REJECTED_QUOTE:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.QUOTE)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.REJECTED_QUOTE)[0]);
      break;
    case loanStatuses.PASSED_QUOTE:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.QUOTE)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.PASSED_QUOTE)[0]);
      break;
    case loanStatuses.CLOSED_LOAN:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.CLOSED_LOAN)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.PAID_OFF)[0]);
      break;
    case loanStatuses.IN_CLOSING:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.CLOSED_LOAN)[0]);
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.IN_CLOSING)[0]);
      break;
    case loanStatuses.PAID_OFF:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.PAID_OFF)[0]);
      break;
    case loanStatuses.WINNING_QUOTE:
      filteredLoanStatuses.push(availableLoanStatuses.filter(x => x.value === loanStatuses.WINNING_QUOTE)[0]);
      break;
    default:
      filteredLoanStatuses.push(...availableLoanStatuses);
      break;
  }

  return filteredLoanStatuses;
}

export function getFilteredDealStatuses(availableDealStatuses, currentDealStatusId) {
  const filteredDealStatuses = [];

  if (!availableDealStatuses || availableDealStatuses.length === 0) {
    return filteredDealStatuses;
  }

  switch (currentDealStatusId) {
    case PIPELINE:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === PIPELINE)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === DEAD)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === CLOSED)[0]);
      break;
    case DEAD:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === PIPELINE)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === DEAD)[0]);
      break;
    case CLOSED:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === CLOSED)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === REFINANCE)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === SOLD)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === ADDING_SUPPLEMENTAL)[0]);
      break;
    case REFINANCE:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === PIPELINE)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === CLOSED)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === REFINANCE)[0]);
      break;
    case ADDING_SUPPLEMENTAL:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === CLOSED)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === REFINANCE)[0]);
      break;
    case SOLD:
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === CLOSED)[0]);
      filteredDealStatuses.push(availableDealStatuses.filter(dealStatus => dealStatus.value === SOLD)[0]);
      break;
    default:
      filteredDealStatuses.push(...availableDealStatuses);
      break;
  }

  return filteredDealStatuses;
}
